(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.service('Auth', function($firebaseAuth) {
        var auth = $firebaseAuth();

        /* Fnction to trigger a login . */
        this.logIn = function(email, pass) {
            return auth.signInWithEmailAndPassword(email, pass).catch(function(error) {

              var errorCode = error.code;
              var errorMessage = error.message;

              if (errorCode === 'auth/wrong-password') {
                alert('Wrong password.');
              } else {
                alert(errorMessage);
              }
            });
        };

        // this.isSignedIn = function(){
        //
        //     console.log('Auth Service, isSignedIn');
        //
        //     return auth.auth().currentUser;
        //
        // };

        return auth;
    });

})();
